
export enum SoundNames {
    anticipation3 = "anticipation3",
    anticipation4 = "anticipation4",
    big_win = "big_win",
    big_win_coins_loop = "big_win_coins_loop",
    big_win_fireworks = "big_win_fireworks",
    big_win_outro = "big_win_outro",
    bonus_bell = "bonus_bell",
    bonus_marker1 = "bonus_marker1",
    bonus_marker2 = "bonus_marker2",
    bonus_marker3 = "bonus_marker3",
    button = "button",
    denom = "denom",
    freespin_music = "freespin_music",
    freespin_ringup = "freespin_ringup",
    freespin_ringup_climax = "freespin_ringup_climax",
    game_menu_close = "game_menu_close",
    game_menu_open = "game_menu_open",
    level1 = "level1",
    level10 = "level10",
    level11 = "level11",
    level12 = "level12",
    level13 = "level13",
    level14 = "level14",
    level2 = "level2",
    level3 = "level3",
    level4 = "level4",
    level5 = "level5",
    level6 = "level6",
    level7 = "level7",
    level8 = "level8",
    level9 = "level9",
    non_win = "non_win",
    reel_spin1 = "reel_spin1",
    reel_stop1 = "reel_stop1",
    set_bet1 = "set_bet1",
    spin_button = "spin_button",
    universal_symbol_win = "universal_symbol_win",
    volume_button = "volume_button"
}
